import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const SupplierAttentionDashboardPage = ({ childRoutes }): React.ReactElement => {
	return (
		<div>
			<Route
				path="/supplier/dashboards"
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: '/supplier/dashboards/overview',
						}}
					/>
				)}
			/>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

export default SupplierAttentionDashboardPage;
